import { useEffect, useState } from 'react';
import { useAboutPageContext } from '../../context';
import AnimatedImage from './animated-image';

const AboutPageInfoAnimation = () => {
    const { hoverImages, clearHoverImages } = useAboutPageContext();
    const [offscreenSet, setOffscreenSet] = useState<Set<number>>(new Set());

    // Clear when all current images are offscreen
    useEffect(() => {
        if (hoverImages.length > 0 && offscreenSet.size === hoverImages.length) {
            clearHoverImages();
        }
    }, [offscreenSet, hoverImages, clearHoverImages]);

    // Reset offscreen state when new images arrive
    useEffect(() => {
        setOffscreenSet(new Set());
    }, [hoverImages]);

    const handleOffscreen = (index: number) => {
        setOffscreenSet(prev => {
            if (prev.has(index)) return prev;
            const next = new Set(prev);
            next.add(index);
            return next;
        });
    };

    return (
        <div className="fixed inset-0 z-10 pointer-events-none">
            {hoverImages.map(({ url, x, y }, i) => (
                <AnimatedImage
                    key={`hover-img-${i}-${url}`} // include url to prevent reuse
                    index={i}
                    url={url}
                    initialX={x}
                    initialY={y}
                    onOffscreen={handleOffscreen}
                />
            ))}
        </div>
    );
};

export default AboutPageInfoAnimation;
